import { Content } from '../../../Models/Content';
import { ContentsActionType, IReceiveViewContentsAction, IRequestViewContentsAction } from './Contents.action-types';

export function requestViewContents(applicationId: string, viewId: string): IRequestViewContentsAction {
  return {
    type: ContentsActionType.REQUEST_VIEW_CONTENTS,
    applicationId,
    viewId,
  };
}

export function receiveViewContents(viewId: string, contents: Content[]): IReceiveViewContentsAction {
  return {
    type: ContentsActionType.RECEIVE_VIEW_CONTENTS,
    viewId,
    contents,
  };
}
